module.exports = __webpack_public_path__ + "img/arbitrum_one.f7e9bc0a.svg";